import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { cvData } from '../data/cvData';

export default function Footer() {
  const { language } = useLanguage();
  const data = cvData[language];
  const currentYear = new Date().getFullYear();
  const rightsText = language === 'de' ? 'Alle Rechte vorbehalten.' : 'All rights reserved.';

  return (
    <footer className="bg-slate-900 text-slate-400 py-8 text-center text-sm">
      <div className="max-w-6xl mx-auto px-6">
        <p>
          &copy; {currentYear} {data.personal.name}. {rightsText}
        </p>
      </div>
    </footer>
  );
}